import * as React from 'react';
import { IPromotionsAnalyticsData } from '../../types/tracking';
import { trackPromotionIconClick } from '../../utils/tracking';

import * as styles from './PromotionIcon.css';
import { mergeStyles } from '@cian/utils';
import { PromotionsBonusIcon, PromotionsMortgageIcon, PromotionsSaleIcon } from '../Icons';
import { ICountrysidePromoItem } from '@cian/api-models/offer-card/v1/get-offer-data';

const ICONS = {
  sale: <PromotionsSaleIcon />,
  bonus: <PromotionsBonusIcon />,
  mortgage: <PromotionsMortgageIcon />,
};

export interface IPromotionIconProps {
  item: ICountrysidePromoItem;
  showTooltip: boolean;
  itemIndex: number;
  href: string;
  analyticsData: IPromotionsAnalyticsData;
  onMouseEnter(index: number): void;
  onMouseLeave(): void;
}

export class PromotionIcon extends React.Component<IPromotionIconProps> {
  public render() {
    const { item, showTooltip, itemIndex, onMouseLeave, href } = this.props;

    return (
      <a
        {...mergeStyles(
          styles['icon-wrapper'],
          styles[`icon-wrapper-${itemIndex + 1}`],
        )}
        target="blank"
        href={`${href}#promotions`}
        onClick={this.onClick}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div className={styles['icon']}>{ICONS[item.type]}</div>
        {showTooltip &&
          <div {...mergeStyles(
            styles['tooltip'],
            styles[`background-${item.type}`],
          )}>
            {item.label}
          </div>
        }
      </a>
    );
  }

  private onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const {
      item,
      itemIndex,
      analyticsData: { offerId, villageId },
    } = this.props;
    trackPromotionIconClick(item.type, itemIndex + 1, offerId, villageId);
    e.stopPropagation();
  }

  private onMouseEnter = () => {
    const { itemIndex, onMouseEnter } = this.props;

    onMouseEnter(itemIndex);
  }
}
